import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';

import Header from './components/Header/Header';
import BlockInvaders from './screens/screenInvaders/BlockInvaders';
import BlockAbout from './screens/screenAbout/BlockAbout';
import BlockServices from './screens/screenServices/BlockServices';
import BlockContacts from './screens/screenContacts/BlockContacts';

import NavUp from './components/NavUp/NavUp';
import NavDown from './components/NavDown/NavDown';

class App extends Component {

  constructor(props)
  {
   super(props);
   this.state = {
                  headerBackgroundClass: "bg-black",
                  navUpBackgroundClass : "not-visible",
                  navDownBackgroundClass : ""
                };
 }

  componentDidMount()
  {
    window.addEventListener("scroll", (e) => this.onWindowScroll(e));
    this.onWindowScroll(null);
  }

  onWindowScroll(e)
  {
      //just a small preformance optimisation
      //if this havent scrolled - set the default values
      let top  = window.pageYOffset || document.documentElement.scrollTop;
      let elements = document.querySelectorAll(".index-block");

      if(top === 0)
      {
        this.setState({navUpBackgroundClass : "not-visible"});
        this.matchBackgroundColorForNavDown(elements)

        return;
      }

      if(top > 0)
      {
        this.setState({navDownBackgroundClass : "not-visible"});
      }


      /*for(let el of elements)
      {
        let pos = el.getBoundingClientRect();
        if(pos.top < 88 && pos.bottom > 88)
        {
        //  let backgroundColor = window.getComputedStyle(el).backgroundColor;
          this.matchBackgroundColorForHeader(el);
          break;
        }
      }*/


      this.matchBackgroundColorForNavUp(elements);

  }

  matchBackgroundColorForNavDown(elements)
  {
    for(let el of elements)
    {
      let pos = el.getBoundingClientRect();
      if(pos.bottom > window.innerHeight)
      {
      //  let backgroundColor = window.getComputedStyle(el).backgroundColor;
        if(el.classList.contains("bg-white"))
        {
          this.setState({navDownBackgroundClass : "text-black"});
        }
        else {
          this.setState({navDownBackgroundClass : "text-white"});
        }
        break;
      }
    }
  }

  matchBackgroundColorForNavUp(elements)
  {
    for(let el of elements)
    {
      let pos = el.getBoundingClientRect();
      if(pos.bottom > window.innerHeight)
      {
      //  let backgroundColor = window.getComputedStyle(el).backgroundColor;
        if(el.classList.contains("bg-white"))
        {
          this.setState({navUpBackgroundClass : "text-black"});
        }
        else {
          this.setState({navUpBackgroundClass : "text-white"});
        }
        break;
      }
    }



  }

  render() {
    return (
      <div className="app">
        <Header backgroundClass={this.state.headerBackgroundClass} />
        <NavUp backgroundClass={this.state.navUpBackgroundClass} />
        <NavDown backgroundClass={this.state.navDownBackgroundClass} />
        <BlockInvaders />
        <BlockAbout />
        <BlockServices />
        <BlockContacts />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js